"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=pharmacy-sale.dto.js.map